import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import UtilsFormule from "../../../utils/UtilsFormule";
import { Alert, Snackbar } from "@mui/material";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import toastr from "toastr";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import AbonnementService from "../../../services/MarketingService/AbonnementService";

const DataTableListAbonnement=({listAbonnement})=>{
  const navigate = useNavigate();

  // const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openDisable, setOpenDisable] = useState(false);
  const [abonnementId, setAbonnementId] = useState(false);
  const [status, setStatus] = useState(false);
  const handleOpenDelete = (row) => {
    setOpenDelete(true)
    setAbonnementId(row.id)
  };
  const handleCloseDelete = () => setOpenDelete(false);
  const handleOpenDisable = (row) => {
    setOpenDisable(true)
    setAbonnementId(row.id)
    setStatus(row.isActive == 1 ? 0 : 1)
    // console.log(row.isActive)
  };
  const handleCloseDisable = () => setOpenDisable(false);
  const { SearchBar } = Search;
  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };
  
  const handleClickDisable = async () => {
    try {
      const response = await AbonnementService.activeOrDesactiveAbonnement(getCurrentUserId(), abonnementId, status);
      toastr.success(response.data.success);
      handleCloseDisable()
      window.location.reload(true);
      // console.log("Carte Cadeau disabled successfully");
    } catch (error) {
      console.error("Error disabling Carte Cadeau:", error);
    }
  };
  const handleClickDelete = async () => {
    try {
      const response = await AbonnementService.deleteAbonnement(getCurrentUserId(), abonnementId, 1);
      toastr.success("Carte Cadeau deleted successfully");
      handleCloseDelete()
      window.location.reload(true);
      // console.log("Carte Cadeau disabled successfully");
    } catch (error) {
      console.error("Error disabling Carte Cadeau:", error);
    }
  }; 
  
  function dateFormatter(cell, row) {
      return (
        <span>
          {UtilsFormule.formatDate(row.creationDate)}
        </span>
      );
    
  }

  function productFormatter(cell, row) {
  
      return (
        <span>
         {row.product.barcode}-{row.product.name}
        </span>
      );    
    
  }
  function libelleFormatter(cell, row) {
    console.log("row", row);
      return (
        <span>
          {row.ref}-{row.name}
        </span>
      );
    
  }

  const actionFormatter = (cell, row) => {
    return (
      <div className="action-buttons">
        <button
          className="btn btn-dark mx-1"
          onClick={() => {
            console.log("Détails", row)
            sessionStorage.setItem("idAbonnement", row.id)
            navigate('/AbonnementDetails')
          }}
        >
          <h6>
            <small>
              {" "}
              <i class="fas fa-eye"></i>
            </small>
          </h6>
        </button>
        <button
          className="btn btn-secondary  mx-1"
          onClick={() => handleOpenDisable(row)}
        >
          <h6>
            <small>
              {" "}
              <i class="fas fa-ban"></i>
            </small>
          </h6>
        </button>
        <button
          className="btn btn-danger mx-1"
          onClick={()=>handleOpenDelete(row)}
        >
          <h6>
            <small>
              {" "}
              <i class="fas fa-trash"></i>
            </small>
          </h6>
        </button>
      </div>
    );
  };
  const columns = [
    
    {
      dataField: "id",
      text: "Libellé",
      formatter: libelleFormatter,
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    
    {
      dataField: "id",
      text: "Produit",
      align: "center",
      headerAlign: "center",
      formatter: productFormatter,
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "creationDate",
      text: "DC",
      align: "center",
      headerAlign: "center",
      formatter: dateFormatter,
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "price",
      text: "Prix",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },  
    {
      dataField: "actions",
      text: "Actions", align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
      formatter: actionFormatter
    }  
  ];


  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  function handleTableChange({ products }) {
    return products;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  return (
    <>
        <ToolkitProvider
          keyField="id"
          data={listAbonnement}
          columns={columns}
          onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                <div className="ml-auto mr-0">
                  <MyExportCSV {...props.csvProps}></MyExportCSV>
                </div>
              </div>
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                />
            </div>
          )}
        </ToolkitProvider>
      <Dialog open={openDelete} onClose={handleCloseDelete}>
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>Voulez-vous vraiment supprimer cette carte cadeau ?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDelete} color="primary">Annuler</Button>
          <Button onClick={() => { handleClickDelete() }} color="error">Supprimer</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openDisable} onClose={handleCloseDisable}>
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>Voulez-vous activer ou désactiver cette carte cadeau ?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDisable} color="primary">Annuler</Button>
          <Button onClick={() => { handleClickDisable() }} color="error">Confirmer</Button>
        </DialogActions>
      </Dialog>

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}
export default DataTableListAbonnement;